import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Button,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download"; // Material-UI download icon
import Loader from "../../helpers/constants/Loader";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import {
  useDocumentStatusMutation,
  useGetCustomerByIdApiMutation,
} from "../../services/registration";
import useTranslation from "../../hooks/Translation";

const CustomerDocuments = () => {
  const { _id } = useParams();
  const t = useTranslation();
  const [ByIdDetails, setByIdDetails] = useState<any>();
  const [documentStatus] = useDocumentStatusMutation();
  const [fetchApi, { isLoading }] = useGetCustomerByIdApiMutation();

  const fetchDataById = async () => {
    try {
      const response = await fetchApi({ id: _id }).unwrap();
      if (response.status === 200) {
        setByIdDetails(response?.data || {});
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangeStatus = async (value: number) => {
    const body = {
      business_verified: value,
    };
    try {
      const response = await documentStatus({ body, id: _id }).unwrap();
      if (response.status === 200) {
        fetchDataById();
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (_id) {
      fetchDataById();
    }
  }, [_id]);

  return (
    <Card className="cards">
      <Loader isLoad={isLoading} />
      <CardContent sx={{ p: 2 }}>
        <Typography variant="h5" gutterBottom style={{ textAlign: "center" }}>
          {t.main.uploadedDocs}
        </Typography>
        <div style={{ margin: 20 }}></div>
        <Grid container spacing={2}>
          {ByIdDetails?.business_registration?.media_url ? (
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Box
                sx={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
                onClick={() =>
                  window.open(
                    ByIdDetails.business_registration.media_url,
                    "_blank"
                  )
                }
              >
                <Typography variant="body1">
                  {t.main.clickToDownload}
                </Typography>
                <Button
                  sx={{
                    minWidth: "unset",
                    padding: 0,
                    marginLeft: 2,
                  }}
                >
                  <DownloadIcon />
                </Button>
              </Box>
            </Grid>
          ) : (
            <Typography sx={{ mt: 2, textAlign: "center", width: "100%" }}>
              {t.error.noDocs}
            </Typography>
          )}
        </Grid>
        <Box mt={2} sx={{ display: "flex", gap: 2 }}>
          {ByIdDetails?.is_business_verified === 2 ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography sx={{ color: "#2B604C" }} variant="body1">
                {t.main.approved}
              </Typography>
              <CheckIcon sx={{ color: "#2B604C" }} />
            </Box>
          ) : ByIdDetails?.is_business_verified === 3 ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography sx={{ color: "red" }} variant="body1">
                {t.main.rejected}
              </Typography>
              <ClearIcon sx={{ color: "red" }} />
            </Box>
          ) : (
            <>
              <Button variant="outlined" onClick={() => handleChangeStatus(2)}>
                {t.main.accept}
              </Button>
              <Button
                color="error"
                variant="outlined"
                onClick={() => handleChangeStatus(3)}
              >
                {t.main.reject}
              </Button>
            </>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default CustomerDocuments;
